import styled from 'styled-components';
import { theme } from '../layout/theme';
import { size } from '../layout/helpers';

export const TabsWrapper = styled.div`
  display: flex;
  gap: ${size(2)};
`;

export const Tab = styled.button`
  font-size: 16px;
  cursor: pointer;
  font-weight: 600;
  &.active {
    border-bottom: 2px solid #000000;
  }
  &:not(.active) {
    font-weight: 400;
    color: #808080;
  }

  ${theme.screens.LtSm} {
    font-size: 14px;
  }
`;
